<template>
  <div
    class="editor-avatars st-floating-avatars"
    :style="avatarsPositionStyle"
  >
    <div
      v-for="(u, i) in users"
      :key="`${u.id}-${i}`"
      class="relative"
    >
      <UserAvatar
        :class="{ 'opacity-50': !isStatusOnline }"
        size="small"
        :member="u"
        :show-user-color="true"
      />
      <div
        v-tooltip="{ content: statusText, placement: 'bottom' }"
        :class="['editor-status-indicator', isStatusOnline ? 'bg-green-500' : 'bg-red-500']"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import UserAvatar from '@/components/widgets/UserAvatar';
import { computed } from 'vue';
import { useStore } from 'vuex';
import useTranslate from '@/utilities/composables/useTranslate';

const store = useStore();
const { translate } = useTranslate();

const props = defineProps<{
  sessionAvatarsPosition?: object;
  users: object[];
  status?: string;
}>();

const avatarsPositionStyle = computed(() => {
  return Object.keys(props.sessionAvatarsPosition || {}).length > 0
    ? props.sessionAvatarsPosition
    : '';
});

const networkStatus = computed(() => store.getters.getOnline);

const isStatusOnline = computed(() => {
  // If indicated as online by service worker, check if collab is connected, otherwise it's offline
  return networkStatus.value ? !props.status || props.status === 'connected' : false;
});

const statusText = computed(() => {
  return translate(isStatusOnline.value ? 'online' : 'disconnected');
});
</script>
<style lang="scss">
.editor-avatars {
  @apply fixed flex flex-col items-center justify-center gap-2 ml-2 p-0.5 rounded-full;
}
.editor-status-indicator {
  @apply w-2.5 h-2.5 flex items-center justify-center absolute -bottom-0.5 -right-1 rounded-full border-2 border-solid border-background-strongest;
}
</style>
